// extracted by mini-css-extract-plugin
export default {"menuItem":"SelectItemFilters_menuItem__RXxnf","title":"SelectItemFilters_title__26DpF"};